export enum OrderStatusEnum {
    Cancelled = 1,
    Completed = 2,
    Error = 3,
    InProgress = 4,
    Incomplete = 5,
    NotReceived = 6,
    PartiallyCompleted = 7,
    ProbeArrived = 8,
    Received = 9,
    ReceivedAwaitingProbe = 10,
    ReceivedPartialOrder = 11,
    AutoCompleted = 100,
}

export const OrderStatusText: { [key in OrderStatusEnum]: string } = {
    [OrderStatusEnum.Cancelled]: 'Cancelled',
    [OrderStatusEnum.Completed]: 'Completed',
    [OrderStatusEnum.Error]: 'Error',
    [OrderStatusEnum.InProgress]: 'In Progress',
    [OrderStatusEnum.Incomplete]: 'Incomplete',
    [OrderStatusEnum.NotReceived]: 'Not Received',
    [OrderStatusEnum.PartiallyCompleted]: 'Partially Completed',
    [OrderStatusEnum.ProbeArrived]: 'Probe Arrived',
    [OrderStatusEnum.Received]: 'Received',
    [OrderStatusEnum.ReceivedAwaitingProbe]: 'Received Awaiting Probe',
    [OrderStatusEnum.ReceivedPartialOrder]: 'ReceivedPartialOrder',
    [OrderStatusEnum.AutoCompleted]: 'Auto-Completed',
};
